import { render, staticRenderFns } from "./RemoveRecruitmentDepthChartModal.vue?vue&type=template&id=03c5b008&"
import script from "./RemoveRecruitmentDepthChartModal.vue?vue&type=script&lang=js&"
export * from "./RemoveRecruitmentDepthChartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports